/*
 * df-cart-enhance.js — Driver del cart drawer df-* (snippets/df-cart-drawer.liquid).
 *
 * Responsabilidades:
 *  - Abrir/cerrar drawer (click [data-toggle-cart] / [data-df-cdrawer-close] / scrim / ESC)
 *  - Sync con cart.js (AJAX): qty +/-, remove, quick-add upsell
 *  - Refresh contenido vía /cart?view=df (template alt) o /cart.js + re-render JS
 *  - Mantener body lock + focus trap
 *  - Disparar evento 'df:cart:updated' para que otros listeners (ship-bar header) reaccionen
 */
(function () {
  'use strict';

  var CONFIG = window.dondefueCart || {};
  var THRESHOLD = (CONFIG.freeShippingThreshold || 0) * 100;
  var SHIPPING_COST = (function () {
    var raw = CONFIG.shippingCost;
    if (raw == null) return 0;
    var n = parseFloat(String(raw).replace(',', '.'));
    return isNaN(n) ? 0 : Math.round(n * 100);
  })();
  var CURRENCY = CONFIG.currency || '€';

  var drawer, panel, itemsList, subtotalEl, countEl, footEl, emptyEl, upsellEl, shipMsg, shipFill, shipSub;
  var lastFocused = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    // Formato de los mocks: "29,95€" pegado (ver snippets/df-eur.liquid)
    return (cents / 100).toFixed(2).replace('.', ',') + CURRENCY;
  }

  function init() {
    drawer = document.getElementById('df-cart-drawer');
    if (!drawer) return;
    panel      = $('.df-cdrawer__panel', drawer);
    itemsList  = $('[data-df-cdrawer-items]', drawer);
    subtotalEl = $('[data-df-cdrawer-subtotal]', drawer);
    countEl    = $('[data-df-cdrawer-count]', drawer);
    footEl     = $('[data-df-cdrawer-foot]', drawer);
    emptyEl    = $('[data-df-cdrawer-empty]', drawer);
    upsellEl   = $('[data-df-cdrawer-upsell]', drawer);
    shipMsg    = $('[data-df-shipprog-msg]', drawer);
    shipFill   = $('[data-df-shipprog-fill]', drawer);
    shipSub    = $('[data-df-shipprog-sub]', drawer);

    // Triggers
    document.addEventListener('click', function (e) {
      var openTrigger = e.target.closest('[data-toggle-cart], [data-df-cart-open]');
      if (openTrigger) {
        e.preventDefault();
        open();
        return;
      }
      var closeTrigger = e.target.closest('[data-df-cdrawer-close]');
      if (closeTrigger) { e.preventDefault(); close(); return; }
    });

    // ESC closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Item qty + remove
    drawer.addEventListener('click', onDrawerClick);

    // Quick-add upsell
    drawer.addEventListener('click', onUpsellQuickAdd);

    // Initial ship bar render
    refreshShipBar(currentTotal());

    // Cross-document hook: listen to other code triggering cart updates
    document.addEventListener('df:cart:open', open);
    document.addEventListener('df:cart:refresh', refresh);
  }

  function open() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('df-cdrawer-open');
    setTimeout(function () { panel && panel.focus(); }, 50);
    // Refresh on every open in case other tabs/pages changed cart
    refresh();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('df-cdrawer-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function currentTotal() {
    // Try to read from data on items; fallback to 0
    var sum = 0;
    $$('[data-df-cditem]', drawer).forEach(function () {});
    return sum; // Will be replaced by fetch
  }

  /*
   * Mantiene la barra de progreso del cajón (snippets/df-shipping-progress)
   * en sintonía con el carrito. El copy tiene que decir lo mismo que el render
   * de servidor del mismo componente, o el cajón y /cart se contradicen en
   * cuanto el usuario cambia una cantidad.
   */
  function refreshShipBar(total) {
    if (!shipMsg || !shipFill || THRESHOLD <= 0) return;
    var shipWrap = shipFill.closest('[data-df-shipprog]');
    var remaining = THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));
    var thresholdEuros = Math.round(THRESHOLD / 100);

    if (remaining <= 0) {
      // Sin el «te ahorras X€»: el Liquid del componente tampoco lo dice, y
      // repetir aquí el importe del envío contradice el pie del cajón, que ya
      // no adelanta esa cifra.
      shipMsg.innerHTML = '<strong>Envío gratis conseguido.</strong>';
      shipFill.style.width = '100%';
      if (shipWrap) shipWrap.classList.add('is-complete');
      if (shipSub) shipSub.setAttribute('hidden', '');
    } else {
      shipMsg.innerHTML = 'Te faltan <strong>' + money(remaining) + '</strong> para el envío gratis.';
      shipFill.style.width = Math.max(2, pct) + '%';
      if (shipWrap) shipWrap.classList.remove('is-complete');
      if (shipSub) {
        if (total > 0) {
          shipSub.textContent = money(total) + ' de ' + thresholdEuros +
            '€ · ahora el envío te cuesta ' + money(SHIPPING_COST);
          shipSub.removeAttribute('hidden');
        } else {
          shipSub.setAttribute('hidden', '');
        }
      }
    }
  }

  function refresh() {
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update count
        if (countEl) countEl.textContent = '(' + cart.item_count + ')';
        // Update subtotal
        if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
        // Update ship bar
        refreshShipBar(cart.total_price);
        // Toggle empty state
        if (cart.item_count === 0) {
          if (emptyEl) emptyEl.removeAttribute('hidden');
          if (footEl) footEl.setAttribute('hidden', '');
          if (upsellEl) upsellEl.setAttribute('hidden', '');
          if (itemsList) itemsList.innerHTML = '';
        } else {
          if (emptyEl) emptyEl.setAttribute('hidden', '');
          if (footEl) footEl.removeAttribute('hidden');
          if (upsellEl) upsellEl.removeAttribute('hidden');
          // Re-render items
          renderItems(cart.items);
        }
        // Notify ship-bar in header
        document.dispatchEvent(new CustomEvent('df:cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  /* «Marco negro / Pequeño (18x24)cm» → «Marco negro · 18×24 cm» */
  function prettyVariant(title) {
    return String(title)
      .split(' / ')
      .map(function (part) {
        var m = part.match(/\(([^)]+)\)/);
        return m ? m[1].replace(/x/i, '\u00D7') + ' cm' : part.trim();
      })
      .join(' \u00B7 ');
  }

  function renderItems(items) {
    if (!itemsList) return;
    var html = items.map(function (it, idx) {
      var img = it.image ? '<img src="' + it.image.replace(/_(small|medium|large|grande)\./, '_160x.') + '" alt="" width="64" height="64" loading="lazy">' : '';
      // Este JS reconstruye las líneas al abrir el cajón y pisaba el formato
      // que pone el Liquid: «Marco negro / Pequeño (18x24)cm» tal cual. Se
      // formatea aquí también, que es donde manda.
      var variant = it.variant_title
        ? '<span class="df-cditem__variant">' + esc(prettyVariant(it.variant_title)) + '</span>'
        : '';
      var props = '';
      if (it.properties) {
        var rows = [];
        for (var k in it.properties) {
          if (!k || k.charAt(0) === '_') continue;
          var v = it.properties[k];
          if (!v) continue;
          var val = String(v);
          if (val.indexOf('/uploads/') !== -1) {
            val = '<a href="' + esc(val) + '" target="_blank" rel="noopener">archivo</a>';
          } else {
            val = esc(val);
          }
          rows.push('<li><span>' + esc(k) + ':</span> ' + val + '</li>');
        }
        if (rows.length) props = '<ul class="df-cditem__props">' + rows.join('') + '</ul>';
      }
      var price = '<div class="df-cditem__price">' +
        (it.original_line_price !== it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') +
        money(it.final_line_price) +
      '</div>';
      return '<li class="df-cditem" data-df-cditem data-key="' + esc(it.key) + '" data-line="' + (idx + 1) + '">' +
        '<a href="' + esc(it.url) + '" class="df-cditem__media">' + img + '</a>' +
        '<div class="df-cditem__body">' +
          '<a href="' + esc(it.url) + '" class="df-cditem__title">' + esc(it.product_title) + '</a>' +
          variant + props +
          '<div class="df-cditem__foot">' +
            '<div class="df-cditem__qty" data-df-cditem-qty>' +
              '<button type="button" class="df-cditem__qty-btn" data-df-cditem-down aria-label="Quitar uno">−</button>' +
              '<span class="df-cditem__qty-val" data-df-cditem-qty-val>' + it.quantity + '</span>' +
              '<button type="button" class="df-cditem__qty-btn" data-df-cditem-up aria-label="Añadir uno">+</button>' +
            '</div>' +
            '<button type="button" class="df-cditem__remove" data-df-cditem-remove aria-label="Quitar artículo">×</button>' +
          '</div>' +
        '</div>' +
        price +
      '</li>';
    }).join('');
    itemsList.innerHTML = html;
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c];
    });
  }

  function onDrawerClick(e) {
    var line = e.target.closest('[data-df-cditem]');
    if (!line) return;
    var key = line.getAttribute('data-key');
    if (!key) return;
    var qtyVal = line.querySelector('[data-df-cditem-qty-val]');
    var current = parseInt((qtyVal && qtyVal.textContent) || '0', 10) || 0;

    if (e.target.closest('[data-df-cditem-up]')) {
      e.preventDefault();
      changeQty(key, current + 1);
    } else if (e.target.closest('[data-df-cditem-down]')) {
      e.preventDefault();
      changeQty(key, Math.max(0, current - 1));
    } else if (e.target.closest('[data-df-cditem-remove]')) {
      e.preventDefault();
      changeQty(key, 0);
    }
  }

  function changeQty(key, qty) {
    if (!window.fetch) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
      credentials: 'same-origin'
    }).then(function () { refresh(); });
  }

  function onUpsellQuickAdd(e) {
    var btn = e.target.closest('[data-df-cdrawer-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-variant-id');
    if (!vid || !window.fetch) return;
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }),
      credentials: 'same-origin'
    }).then(function () {
      btn.textContent = '✓';
      setTimeout(function () { btn.textContent = prev; btn.disabled = false; }, 900);
      refresh();
    }).catch(function () {
      btn.textContent = prev;
      btn.disabled = false;
    });
  }

  // ==========================================================
  // PDP CTA spinner — el botón principal [data-df-add] en df-main-product
  // tiene <svg class="loading-icon" style="display:none"> que ningún JS
  // estaba activando. El usuario veía "se queda pensando" porque sin AJAX
  // interceptor el form recargaba la página antes de ocultar nada.
  //
  // Estrategia: interceptar submit del form PDP, hacer AJAX a /cart/add.js,
  // mostrar spinner, mostrar ✓ on success, refresh drawer + dispatch event.
  // ==========================================================
  function setCtaState(btn, state) {
    if (!btn) return;
    var cartIcon = btn.querySelector('.cart-icon');
    var loadingIcon = btn.querySelector('.loading-icon');
    var label = btn.querySelector('[data-df-cta-label]');
    var originalLabel = btn.getAttribute('data-df-original-label');
    if (!originalLabel && label) {
      btn.setAttribute('data-df-original-label', label.innerHTML);
      originalLabel = label.innerHTML;
    }
    if (state === 'loading') {
      if (cartIcon) cartIcon.style.display = 'none';
      if (loadingIcon) loadingIcon.style.display = 'inline-block';
      btn.disabled = true;
      btn.classList.add('is-adding');
    } else if (state === 'success') {
      if (loadingIcon) loadingIcon.style.display = 'none';
      if (cartIcon) cartIcon.style.display = 'inline-flex';
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      if (label) label.innerHTML = '<span style="font-weight:700">✓ Añadido al carrito</span>';
    } else {
      // reset
      if (loadingIcon) loadingIcon.style.display = 'none';
      if (cartIcon) cartIcon.style.display = 'inline-flex';
      btn.disabled = false;
      btn.classList.remove('is-adding', 'is-added');
      if (label && originalLabel) label.innerHTML = originalLabel;
    }
  }

  function onPdpFormSubmit(e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var btn = form.querySelector('[data-df-add]');
    if (!btn) return; // not our PDP CTA → let other handlers run
    e.preventDefault();
    var errorBox = form.querySelector('.product-converter__error');
    if (errorBox) errorBox.textContent = '';
    setCtaState(btn, 'loading');

    // 🎬 Lanza la animación fly-to-cart INMEDIATAMENTE (no espera el fetch)
    flyToCart(form);

    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      setCtaState(btn, 'success');
      // Refresh drawer contents
      refresh();
      // Pulse cart icon header + counter pop
      pulseCart();
      // Notify other listeners (header counter, ship-bar)
      document.dispatchEvent(new CustomEvent('df:cart:updated'));
      // Open drawer DESPUÉS de la animación fly (espera 700ms)
      setTimeout(function () {
        if (drawer && drawer.classList) {
          var toggle = document.querySelector('[data-toggle-cart]');
          if (toggle) toggle.click();
        }
      }, 700);
      // Reset CTA después de 2s
      setTimeout(function () { setCtaState(btn, null); }, 2000);
    }).catch(function (err) {
      setCtaState(btn, null);
      if (errorBox) {
        errorBox.textContent = (err && err.description) || 'No se pudo añadir. Intenta de nuevo.';
      }
    });
  }
  document.addEventListener('submit', onPdpFormSubmit);

  /* ============================================================
   * 🎬 FLY-TO-CART ANIMATION
   * Clona la imagen del producto y la "lanza" en arco hacia el icono
   * del carrito del header, con scale + rotation + fade.
   * Al llegar, lanza confetti burst desde el icono y hace pulse al
   * counter del carrito.
   * Respeta prefers-reduced-motion.
   * ============================================================ */
  function flyToCart(form) {
    // Respeta accesibilidad
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // 1. Buscar la imagen de origen (la imagen activa del gallery PDP)
    var sourceImg = document.querySelector(
      '.df-pdp__media-item.is-active img.df-pdp__media-img, ' +
      '.df-pdp__media-img, ' +
      '.product-converter__media img, ' +
      'main img'
    );
    if (!sourceImg || !sourceImg.src) return;

    // 2. Buscar el target (icono del carrito en header)
    var target = document.querySelector(
      '[data-toggle-cart], .df-header__cart, [data-df-cart-count]'
    );
    if (!target) return;

    var srcRect = sourceImg.getBoundingClientRect();
    var dstRect = target.getBoundingClientRect();

    // Si la imagen está fuera del viewport, no animar
    if (srcRect.bottom < 0 || srcRect.top > window.innerHeight) return;

    // 3. Clonar la imagen y posicionarla absoluta
    var flyer = document.createElement('div');
    flyer.className = 'df-fly-to-cart';
    flyer.style.cssText = [
      'position: fixed',
      'left: ' + srcRect.left + 'px',
      'top: ' + srcRect.top + 'px',
      'width: ' + srcRect.width + 'px',
      'height: ' + srcRect.height + 'px',
      'border-radius: 14px',
      'overflow: hidden',
      'background: #fff',
      'box-shadow: 0 12px 32px rgba(21,17,13,.18)',
      'pointer-events: none',
      'z-index: 99999',
      'will-change: transform, opacity',
      'transition: none',
      'transform-origin: center center'
    ].join(';');
    var flyImg = document.createElement('img');
    flyImg.src = sourceImg.currentSrc || sourceImg.src;
    flyImg.alt = '';
    flyImg.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
    flyer.appendChild(flyImg);
    document.body.appendChild(flyer);

    // 4. Calcular trayectoria: origen → arc → destino
    var dstX = dstRect.left + dstRect.width / 2 - srcRect.left - srcRect.width / 2;
    var dstY = dstRect.top + dstRect.height / 2 - srcRect.top - srcRect.height / 2;

    // 5. Animación en 2 fases:
    // Fase A (0→50%): el clon hace "pop" (scale 1.05) y se levanta un poco
    // Fase B (50→100%): viaja al cart con scale 0.18 y rotation
    requestAnimationFrame(function () {
      // Phase A: pop
      flyer.style.transition = 'transform .22s cubic-bezier(.34,1.56,.64,1)';
      flyer.style.transform = 'translate(0, -10px) scale(1.05) rotate(-3deg)';

      setTimeout(function () {
        // Phase B: throw to cart
        flyer.style.transition =
          'transform .58s cubic-bezier(.55,.05,.4,1), ' +
          'opacity .58s ease-in';
        flyer.style.transform =
          'translate(' + dstX + 'px, ' + dstY + 'px) ' +
          'scale(0.16) rotate(28deg)';
        flyer.style.opacity = '0.4';

        setTimeout(function () {
          // Cleanup + impact effects
          flyer.style.opacity = '0';
          setTimeout(function () { flyer.remove(); }, 120);
          impactAtCart(target);
        }, 580);
      }, 220);
    });
  }

  /* === Impacto en el cart al recibir el item: bounce + confetti === */
  function impactAtCart(target) {
    // 1. Cart icon bounce
    if (!target.classList.contains('df-cart-impact')) {
      target.classList.add('df-cart-impact');
      setTimeout(function () { target.classList.remove('df-cart-impact'); }, 720);
    }

    // 2. Mini confetti burst desde el cart
    var rect = target.getBoundingClientRect();
    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;
    var colors = ['#DC1E2A', '#ffd166', '#06d6a0', '#15110d', '#DC1E2A'];
    for (var i = 0; i < 10; i++) {
      (function (idx) {
        var p = document.createElement('span');
        p.className = 'df-cart-confetti';
        p.style.cssText = [
          'position: fixed',
          'left: ' + cx + 'px',
          'top: ' + cy + 'px',
          'width: 7px',
          'height: 7px',
          'background: ' + colors[idx % colors.length],
          'border-radius: 2px',
          'pointer-events: none',
          'z-index: 99998',
          'opacity: 1',
          'transform: translate(-50%, -50%) rotate(' + (Math.random() * 360) + 'deg)',
          'transition: transform .92s cubic-bezier(.34,1.1,.64,1), opacity .92s ease-out'
        ].join(';');
        document.body.appendChild(p);
        requestAnimationFrame(function () {
          var angle = (idx / 10) * Math.PI * 2 + Math.random() * 0.4;
          var dist = 60 + Math.random() * 60;
          var dx = Math.cos(angle) * dist;
          var dy = Math.sin(angle) * dist - 20; // bias up
          p.style.transform =
            'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) ' +
            'rotate(' + (Math.random() * 540) + 'deg)';
          p.style.opacity = '0';
        });
        setTimeout(function () { p.remove(); }, 1000);
      })(i);
    }
  }

  /* === Cart icon pulse + counter pop === */
  function pulseCart() {
    var cart = document.querySelector('[data-toggle-cart], .df-header__cart');
    if (cart) {
      cart.classList.add('df-cart-pulse');
      setTimeout(function () { cart.classList.remove('df-cart-pulse'); }, 600);
    }
    var counter = document.querySelector('[data-df-cart-count]');
    if (counter) {
      counter.classList.remove('df-cart-count-pop');
      // reflow para reiniciar animación
      void counter.offsetWidth;
      counter.classList.add('df-cart-count-pop');
      setTimeout(function () { counter.classList.remove('df-cart-count-pop'); }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
